import api from '@/apis'

export const fetchList = params => api.get(`/managers`, { params })
export const setActiveState = (id, isActive) => api.put(`/managers/${id}/set_active`, { isActive })
export const setExt = (id, data) => api.put(`/managers/${id}/set_ext`, data)
export const fetchGroupManager = params => api.get(`/managers/find_group_manager`, params)
